import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from "formik"
import * as Yup from "yup"
import { useNavigate, useParams } from 'react-router-dom'

// components
import AppCard from '../../components/AppCard'
import AppForm from '../../components/form/form-client-voucher/AppForm'
import ActionButtonForm from 'src/components/form/general-input-form/ActionButtonForm'
import AppModalConfirmation from '../../components/modal/AppModalConfirmation'

// helpers
import Axios from '../../helpers/axios'

const EditClientVoucher = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const { id } = params

  const isLoading = useSelector((state) => state.isLoading)

  const [clientVoucherDetail, setClientVoucherDetail] = useState(null)
  const [showModalConfirm, setShowModalConfirm] = useState({ show: false })

  const formik = useFormik({
    initialValues: {
      clientvoucher_client_code: clientVoucherDetail?.client_code || '',
      clientvoucher_is_used: clientVoucherDetail?.is_used || false,
      clientvoucher_is_game_pass: clientVoucherDetail?.is_game_pass || false,
    },
    validationSchema: Yup.object().shape({
      clientvoucher_client_code: Yup.string()
        .required("Please enter client code."),
    }),
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });

  useEffect(() => {
    fetchDetailClientVoucher()
  }, [id])

  const fetchDetailClientVoucher = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/gamepass/v1/voucher/client/detail/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setClientVoucherDetail(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleInputValue = (values) => {
    let data = {
      client_code: values.clientvoucher_client_code,
      is_used: values.clientvoucher_is_used,
      is_game_pass: values.clientvoucher_is_game_pass,
    }

    return data
  }

  const handlePost = (payload) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "put",
      url: `/api/gamepass/v1/voucher/client/update/${id}`,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          navigate(`/client-voucher/details/${id}`)
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleSave = (values) => {
    const inputPayload = handleInputValue(values)
    handlePost(inputPayload)
  }

  const handleSubmit = () => {
    formik.handleSubmit()

    setShowModalConfirm({ show: false })
  }

  const handleSwitch = (e, name) => {
    let checked = e.target.checked

    formik.setValues((prevValues) => ({
      ...prevValues,
      [name]: checked
    }), false)
  }

  return (
    <>
      {
        showModalConfirm.show && (
          <AppModalConfirmation 
            confirmationType="confirmation"
            showModal={showModalConfirm}
            setShowModal={setShowModalConfirm}
            headerTitle="Confirmation"
            descriptionText="Are you sure want to edit this client voucher?"
            handleSubmit={handleSubmit}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
          />
        )
      }
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Edit Client Voucher</h4>}
        bodyContent={
          <AppForm 
            values={formik.values}
            handleChange={formik.handleChange}
            errors={formik.errors}
            handleSwitch={handleSwitch}
          />
        }
        footerContent={
          <ActionButtonForm
            isLoading={isLoading}
            disabled={formik.isSubmitting}
            onCancel={() => navigate('/client-voucher/list')}
            onSave={() => setShowModalConfirm({ show: true })}
          />
        }
      />
    </>
  )
}

export default EditClientVoucher